<template>
  <div class="badge" :class="badgeClass">{{order.state}}</div>
</template>

<script>
export default {
  props: {
    order: Object
  },
  computed: {
    badgeClass() {
      if(this.order.state === 'canceled')
        return 'badge-danger'
      if(this.order.state === 'fulfilled')
        return 'badge-success'
      if(this.order.state === 'toBeFulfilled')
        return 'badge-warning'
      return 'badge'
    }
  }
}
</script>
